import { render, staticRenderFns } from "./register_by_authorized_person.vue?vue&type=template&id=69a8b031"
import script from "./register_by_authorized_person.vue?vue&type=script&lang=js"
export * from "./register_by_authorized_person.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports